import { HelpQueriesView } from '@shared-ui/help-queries';
import { adminThreadApi } from '../../../api/adminThreadApi';
import { authApi } from '../../../api/auth';

export function HelpQueriesTab({ userId }: { userId: string }) {
    const admin = authApi.getUser();
    return (
        <HelpQueriesView
            threadApi={adminThreadApi}
            role="admin"
            listFilters={{ ownerId: userId, type: 'student_teacher' }}
            showKindFilter
            queryKey={['admin-user-help-queries', userId]}
            currentUserId={admin?.id}
            canReply={false}
            canChangeStatus={false}
            markSeenOnView={false}
            participantLabel="Student"
            emptyMessage="This teacher has no help queries."
        />
    );
}
